import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { MultiSelectTextComponent } from '../components/multi-select-text.component';

export function MultiSelectTextContainer ({ isDisabled, isRequired, label, onValueChangeCallback, value }: any) {

const [inputValue, setInputValue] = useState('');
const [selected, setSelected] = useState<any>([]);
const [open, setOpen] = useState(false);

  const handleButtonClick = () => {
    setOpen(!open);
  };
 
  useEffect(() => {
    if (value?.length && !selected.length) {
      const mappedValue = value.map((val:any) => ({ 
        id: val, label:val, isNew: true }));
      setSelected(mappedValue);
    }
  }, [value]);
  
  const filtered = inputValue === '' ? selected : selected.filter((data: any) => {
    return data.label.toLowerCase().includes(inputValue.toLowerCase());
  });
  const handleAddOption = () => {
    if (inputValue.trim() !== '') {
      const newOption = { id: inputValue, label: inputValue.trim(), isNew: true };
      setSelected([...selected, newOption]);
      setInputValue('');
    }
  };

  const handleInputChange = (event:any) => {
    const newQuery = event.target.value.trim().split(',').pop().trim();
    setInputValue(newQuery);
  };
  const handleOptionClick = (value: any) => {
    const index = selected.findIndex((data: any) => data.id === value.id);
    if (index === -1) {
      setSelected([...selected, value]);
    } else {
      const updatedSelected = [...selected];
      updatedSelected.splice(index, 1);
      setSelected(updatedSelected);
    }
  };
  const handleInputKeyDown = (event:any) => {
    if (event.key === 'Enter') {
      handleAddOption();
    }
  };
  const displaySelected = () => {
    const selectedLabel = selected.map((data: any) => data.label);
    return selectedLabel.length === 0 ? '' : selectedLabel + ',' + (inputValue.trim() !== '' ? ', ' + inputValue.trim() : '');
  };
  useEffect(() => {
    onValueChangeCallback(selected);
}, [selected]);

  return (<MultiSelectTextComponent
    label={label}
    filtered={filtered}
    open={open}
    handleOptionClick={handleOptionClick}
    onValueChange={(newValue: any) =>{ 
        setSelected(newValue);
      }}
    isDisabled={isDisabled}
    handleInputChange={handleInputChange}
    selected={selected}
    handleInputKeyDown={handleInputKeyDown}
    displaySelected={displaySelected}
    handleButtonClick={handleButtonClick}
    isRequired={isRequired}
    multiple
    handleAddOption={handleAddOption}
          />
  )
}